import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './PaymentSuccess.css';

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [countdown, setCountdown] = useState(10);
  
  // Get booking details from location state
  const bookingId = location.state?.bookingId || 'XXXX';
  const amount = location.state?.amount || 0;

  useEffect(() => {
    // Auto-redirect countdown
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          navigate('/dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleDownloadInvoice = () => {
    // Mock invoice download
    alert('Rechnung wird heruntergeladen... (Demo)');
  };

  const handleViewBooking = () => {
    navigate('/dashboard');
  };

  return (
    <div className="payment-success-container">
      <div className="success-card">
        <div className="success-icon">
          <div className="checkmark-circle">
            <svg className="checkmark" viewBox="0 0 52 52">
              <circle className="checkmark-circle-bg" cx="26" cy="26" r="25" fill="none"/>
              <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
          </div>
        </div>

        <h1>Zahlung erfolgreich!</h1>
        <p className="success-message">
          Vielen Dank für Ihre Anzahlung. Ihre Buchung wurde bestätigt.
        </p>

        <div className="payment-details">
          <div className="detail-box">
            <span className="detail-label">Buchungsnummer</span>
            <span className="detail-value">#{bookingId}</span>
          </div>
          <div className="detail-box">
            <span className="detail-label">Gezahlter Betrag</span>
            <span className="detail-value amount">€{(amount / 100).toFixed(2)}</span>
          </div>
        </div>

        <div className="next-steps">
          <h3>Nächste Schritte:</h3>
          <ul>
            <li>
              <span className="step-icon">📧</span>
              <div>
                <strong>Bestätigungs-E-Mail</strong>
                <p>Sie erhalten in Kürze eine E-Mail mit allen Details</p>
              </div>
            </li>
            <li>
              <span className="step-icon">📅</span>
              <div>
                <strong>25 Tage vor der Fahrt</strong>
                <p>Sie erhalten die Schlussrechnung per E-Mail</p>
              </div>
            </li>
            <li>
              <span className="step-icon">🍽️</span>
              <div>
                <strong>35 Tage vor der Fahrt</strong>
                <p>Erinnerung zur Essensauswahl für Ihre Gruppe</p>
              </div>
            </li>
            <li>
              <span className="step-icon">🎫</span>
              <div>
                <strong>Nach Zahlung der Schlussrechnung</strong>
                <p>Sie erhalten Ihr Bordticket mit Anfahrtsskizze</p>
              </div>
            </li>
          </ul>
        </div>

        <div className="action-buttons">
          <button 
            className="btn-primary"
            onClick={handleViewBooking}
          >
            Zur Buchungsübersicht
          </button>
          <button 
            className="btn-secondary"
            onClick={handleDownloadInvoice}
          >
            Rechnung herunterladen
          </button>
        </div>

        <div className="auto-redirect">
          <p>Sie werden in <strong>{countdown}</strong> Sekunden automatisch weitergeleitet...</p>
        </div>

        <div className="support-info">
          <p>Haben Sie Fragen? Kontaktieren Sie uns:</p>
          <div className="contact-options">
            <a href="tel:+49123456789">📞 +49 123 456789</a>
            <a href="mailto:info@frankenfloss.de">✉️ info@frankenfloss.de</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
